import React from "react";

const DownloadTaskReport = ({ handleTaskReportExport, isDownloading = false }) => {
  return (
    <div>
      <button
        className="c-b-btn"
        onClick={() => handleTaskReportExport()}
        disabled={isDownloading}
      >
        <img src="/assets/images/report-icon.svg" alt="" className="me-2" />
        {isDownloading ? "Generating..." : "Download Task Report"}
      </button>
    </div>
  );
};

export default DownloadTaskReport;
